export const ANONYMOUS_DONOR = {
  name: "Anonym Giver",
  email: "anon@gieffektivt.no",
  taxDeduction: false,
  ssn: "",
  newsletter: false,
} as const;
